import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import { mapErrorCode } from './errorMapper.js';
import { ApiError } from './envelope.js';
import { notifySessionError } from '../auth/sessionErrors.js';

export function createAppQueryClient(): QueryClient {
  return new QueryClient({
    queryCache: new QueryCache({
      onError: (error) => {
        if (error instanceof ApiError) notifySessionError(error.code);
      },
    }),
    mutationCache: new MutationCache({
      onError: (error) => {
        if (error instanceof ApiError) notifySessionError(error.code);
      },
    }),
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        retry: 1,
        refetchOnWindowFocus: false,
      },
      mutations: {
        retry: 0,
      },
    },
  });
}

export function getQueryErrorMessage(error: unknown): string {
  if (error instanceof ApiError) {
    return mapErrorCode(error.code, error.message);
  }
  if (error instanceof Error) {
    return error.message;
  }
  return mapErrorCode('ERR-UNKNOWN');
}
